let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9RypW")).then(() => parcelRequire('hd6X6'));